import H4 from '@base/H4/H4';
import styled from '@emotion/styled';
import { mediaQuery, Spacings } from '@styles/index';
import CardCarousel from '@cont/PreSubscribed/CardCarousel';
import PracticeCard from './PracticeCard';

const Wrapper = styled.div`
  grid-column: span 18;
  margin-top: ${Spacings.SPACING_5B};
  margin-bottom: ${Spacings.SPACING_10B};

  ${mediaQuery.uptoMobile} {
    margin-bottom: ${Spacings.SPACING_6B};
  }

  & > .carousel-container {
    width: 847px;
    margin-top: ${Spacings.SPACING_5B};
    margin-left: 0;
    ${mediaQuery.uptoMobile} {
      width: 100%;
      overflow-x: auto;
    }
    ${mediaQuery.uptoTablet} {
      overflow: hidden;
    }
    .MuiIconButton-root {
      z-index: 2;
    }
  }
`;

const PracticeByEducators = ({ data }) => {
  if (!data) {
    return null;
  }
  const renderPractices = () => {
    return data?.dppCards?.map((practice) => (
      <PracticeCard key={practice.uid} practice={practice} />
    ));
  };
  return (
    <Wrapper>
      <H4>Practice By Educators </H4>
      <CardCarousel step={1} rightShadowDiv={false} height="207px">
        {renderPractices()}
      </CardCarousel>
    </Wrapper>
  );
};

export default PracticeByEducators;
